<template>
    <div class="star-rating">
        <div class="star-rating__star" :class="{ 'active': star <= stars }" v-for="star in maxStars" :key="star" @click="rate(star)">
            <Icon name="star"></Icon>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            maxStars: 5,
            stars: 0,
        }
    },
    methods: {
      rate(star) {
        if (
          typeof star === 'number' &&
          star <= this.maxStars &&
          star >= 0
        )
          this.stars = this.stars === star ? star - 1 : star
          this.$emit('ratingUpdate', this.stars)
      }
    }
}
</script>

<style scoped lang="scss">

.star-rating {
    $block: &;

    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      #{$block}__star {
        opacity: 0.5;
      }
    }

    &__star {
        padding: 0 12px;
        opacity: 0.3;
        cursor: pointer;
        transition: opacity 200ms $ease-out-quad;

        @include mq($until: tablet) {
            padding: 0 6px;
        }

        &.active {
            opacity: 1 !important;
        }

        &:hover {
            & ~ #{$block}__star {
                &:not(.active) {
                    opacity: 0.3;       
                }
            }
        }
    }
}

</style>